module.exports = __webpack_public_path__ + "img/featureSlide04Img_01.1bbe7fc4.png";